import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { usePlatformConfig } from "@/hooks/usePlatformConfig";
import { initGA, initMetaPixel } from "@/lib/analytics";

/**
 * Initializes platform-level Google Analytics 4 and Meta Pixel
 * using IDs configured in the Super Admin panel.
 * Sends page_view on every route change.
 */
export function usePlatformAnalytics() {
  const { config, loading } = usePlatformConfig();
  const location = useLocation();
  const initialized = useRef(false);

  // Init scripts once config is loaded
  useEffect(() => {
    if (loading || initialized.current) return;
    initialized.current = true;

    if (config.platform_ga_measurement_id) {
      initGA(config.platform_ga_measurement_id);
    }
    if (config.platform_meta_pixel_id) {
      initMetaPixel(config.platform_meta_pixel_id);
    }
  }, [loading, config.platform_ga_measurement_id, config.platform_meta_pixel_id]);

  // Send page_view on route changes (GA handles first page_view via config)
  useEffect(() => {
    if (!initialized.current) return;

    if (window.gtag && config.platform_ga_measurement_id) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname, location.search]);
}
